import 'jquery-validation';

// $ is imported and assigned to window.
export default (form, options) => window.$(form).validate(options);
